import script from "./DynamicTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicTable.vue?vue&type=script&setup=true&lang=js"

import "./DynamicTable.vue?vue&type=style&index=0&id=09f5a69a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f5a69a"]])

export default __exports__